export default "__VITE_ASSET__CVZCGJ$V__"